import I18n from 'I18n';
import Raven from 'raven-js';

export const getAiControlTypeText = (controlType: string) => {
  switch (controlType) {
    case 'GENERATIVE_AI':
      return I18n.text(
        'detailsPage.aiAccessControls.controlTypes.GENERATIVE_AI'
      );
    case 'CRM_PROPERTIES':
      return I18n.text(
        'detailsPage.aiAccessControls.controlTypes.CRM_PROPERTIES'
      );
    case 'CONVERSATION_DATA':
      return I18n.text(
        'detailsPage.aiAccessControls.controlTypes.CONVERSATION_DATA'
      );
    case 'FILE_DATA':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.FILE_DATA');
    case 'COPILOT':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.COPILOT');
    default: {
      const errorMessage = 'Cannot get control type text for control type';
      Raven.captureMessage(errorMessage, {
        extra: {
          controlType,
        },
      });
      throw new Error(errorMessage);
    }
  }
};
